/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SalesOrderInstallment = {
  /**
   * Unique installment identifier
   */
  id: number;
  /**
   * Installment number
   */
  installmentNumber: number;
  /**
   * Total installments
   */
  installmentTotal: number;
  /**
   * Due date
   */
  dueDate: string;
  /**
   * Installment amount
   */
  amount: number;
  /**
   * Installment status
   */
  status: SalesOrderInstallment.status;
  /**
   * Paid date
   */
  paidDate?: string;
  /**
   * Late fee amount
   */
  lateFee: number;
  /**
   * Installment notes
   */
  notes?: string;
  /**
   * Creation timestamp
   */
  createdAt: string;
};
export namespace SalesOrderInstallment {
  /**
   * Installment status
   */
  export enum status {
    PENDING = 'PENDING',
    PAID = 'PAID',
    OVERDUE = 'OVERDUE',
    CANCELLED = 'CANCELLED',
  }
}
